import React from 'react'

import type { TSFTPSource } from '../../../types/tracking'
import { StatusIcon } from '../status-icon'
import { TrackingTimeDisplay } from '../tracking-time-display'

interface ISFTPTrackingInfo {
  trackingSourceData: TSFTPSource
}

/**
 * The component that displays the SFTP info in a tooltip
 */
export const SFTPTrackingInfo = (props: ISFTPTrackingInfo) => {
  const { trackingSourceData } = props
  const trackingSourceMetadata = trackingSourceData?.metadata

  return (
    <div className="flex w-full flex-col space-y-2 items-start">
      <p className="text-md font-semibold ">
        This data is being sent by {trackingSourceData?.metadata?.sender?.sftpUsername || 'the carrier'} through SFTP
      </p>

      {!!trackingSourceMetadata?.sender?.truckNumber && (
        <p className="max-w-[400px] line-clamp-4">Truck: {trackingSourceMetadata.sender.truckNumber}</p>
      )}

      {!!trackingSourceMetadata?.sender?.trailerNumber && (
        <p className="max-w-[400px] line-clamp-4">Trailer: {trackingSourceMetadata.sender.trailerNumber}</p>
      )}

      {!!trackingSourceData?.locations?.length && trackingSourceData.locations.length > 0 && (
        <TrackingTimeDisplay
          filterReason={trackingSourceData.filterReason}
          lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
          lastLocationTimestamp={trackingSourceData.locations[trackingSourceData.locations.length - 1]?.timestamp}
          wrapper="p"
        />
      )}

      <div className="flex items-center space-x-2">
        <StatusIcon isPositive={Boolean(trackingSourceData.locations?.length)} />
        <span>Status: {trackingSourceData?.locations?.length ? 'Tracking' : 'Not tracking'}</span>
      </div>
    </div>
  )
}
